import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MuiTooltip } from '@mui/material';
export const Tooltip = ({ children, onClose = undefined, onOpen = undefined, placement = 'bottom', text, ...muiProps }) => (_jsx(MuiTooltip, { ...muiProps, placement: placement, onOpen: onOpen, onClose: onClose, title: text, arrow: true, children: children }));
//# sourceMappingURL=index.js.map